// common api

import { useDispatch } from 'react-redux';
import Api from '../../api2';
import { createAsyncThunk } from '@reduxjs/toolkit';
import userReducer from '../../redux/slice/userSlice';

/**
 * @param {*} data
 */
//DVHC

//Profile
// export const getProfile = createAsyncThunk('common/getProfile', async (user) => {
//     var dulieu = null;
//     // dispatch(getProfile({user: user, setLoading: setLoading, loading: loading}));
//     await new Api()
//         .Profile({ token: user.access_token })
//         .then((data) => {
//             if (data.code === 200) {
//                 dulieu = { ...data.data.result };
//             } else {
//                 localStorage.removeItem("accessToken");
//             }
//         })
//         .catch((err) => {})
//     return dulieu;
// });
export const getProfile = createAsyncThunk('common/getProfile', async ({user, setLoading, loading}) => {
    var dulieu = null;
    await new Api()
        .Profile({ token: user.access_token })
        .then((data) => {
            if (data.code === 200) {
                dulieu = { ...data.data.result };
            } else {
                localStorage.removeItem("accessToken");
            }
        })
        .catch((err) => {})
        .finally(() => {                
            if (loading) {
                setLoading(false)
            }
        })
    return dulieu;
});
//Functions By Role
export const getFunctionsByRole = createAsyncThunk('common/getFunctionsByRole', async (user) => {
    var dulieu = null;
    await new Api()
        .getFunctionsByRole({ token: user.access_token })
        .then((data) => {
            if (data.code === 200) {
                dulieu = data.data.result;
            }
        })
        .catch((err) => {});
    return dulieu;
});
//Tỉnh
export const getTinhs = createAsyncThunk('common/getTinhs', async (user) => {
    var dulieu = null;
    await new Api()
        .getListAllTinhThanhs({
            token: user.access_token,
        })
        .then((data) => {
            if (data.code === 200) {
                dulieu = data.data.records;
            }
        })
        .catch((err) => {});
    return dulieu;
});
//Tỉnh
export const getAllDms = createAsyncThunk('common/getAllDms', async (user) => {
    var dulieu = null;
    await new Api()
        .getAllDanhMucs({
            token: user.access_token,
        })
        .then((data) => {
            if (data.code === 200) {
                dulieu = data?.data;
            }
        })
        .catch((err) => {});
    return dulieu;
    //
});
//KinhTuyenTruc
export const getKinhTuyenTruc = createAsyncThunk('common/getKinhTuyenTruc', async ({ user, cap }) => {
    var dulieu = {};
    await new Api()
        .getKinhTuyentruc({ token: user.access_token, cap: cap })
        .then((data) => {
            if (data.code === 200) {
                let dataktt = data?.data?.result?.data.map((vl) => ({ ...vl, tenKTT: vl.ten + ' (' + vl.tenDVHC + ')' }));
                dulieu = { data: dataktt, cap: cap };
            }
        })
        .catch((err) => {});
    return dulieu;
});
